export default __webpack_public_path__ + "23ab1efa3bf9dab57b12b20c66aa05a2.svg";